import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import Modal from "./common/modal";
import { selectAuthenticated, selectSubscribed } from "../selectors";
import { ReactGA } from "../analytics";

const triggerModal = ({ authenticated, views }) => {
  if (authenticated && views <= 1) return false; // don't show logged in users on first page view

  return Math.random() > 0.99;
};

export const PatreonCta = () => {
  const [views, setViews] = useState(0);
  const [visible, setVisible] = useState(false);
  const [shown, setShown] = useState(false);
  const subscribed = useSelector(selectSubscribed);
  const authenticated = useSelector(selectAuthenticated);
  const location = useLocation();
  const clearModal = useCallback(() => {
    setShown(true);
    setVisible(false);
  }, [setShown, setVisible]);
  const trackVisitedPatreon = useCallback(() => {
    ReactGA.event({
      category: "Conversion",
      action: "Visited Patreon from modal",
    });
  }, []);

  useEffect(() => {
    setViews(views + 1);
  }, [location]);

  if (subscribed || shown) return null;

  if (triggerModal({ authenticated, views })) {
    ReactGA.modalview("patreon-cta");
    setVisible(true);
  }

  return (
    <Modal
      show={visible}
      onHide={clearModal}
      title="Interested in becoming a Patron?"
    >
      <p>Hey there!</p>

      <p>
        iborrowdesk.com has been around for over 5 years thanks in large part to
        the support of Patrons. If you find the site useful I'd really
        appreciate your support!
      </p>

      <p>
        By contributing as little as $1/month you'll enjoy an advertising-free
        experience and some additional benefits.
      </p>

      <p>
        Find out more at{" "}
        <a
          href="https://www.patreon.com/iborrowdesk"
          target="_blank"
          onClick={trackVisitedPatreon}
        >
          www.patreon.com/iborrowdesk
        </a>
        .
      </p>
    </Modal>
  );
};
